import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import Logo from '../assets/img/ibridge-logo.png';
// import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import '../../assets/css/candidate-tab-form.css';
import '../../assets/css/inner-tabs.css';
import TickIconBlack from '../../assets/img/tick-icon-black.png';
// import CrossIcon from '../assets/img/cross-icon.png';
import UploadIcon from '../../assets/img/upload-icon.svg';
// import ArrowRightIcon from '../assets/img/arrow-right-icon.png';
// import InputFieldEducation from "./InputFieldEducation";
//this is import just to grab upload file functionality
import {
  uploadFileViaMultipart,
} from "../../Actions/personalDetailsActions";
import ABSelect from '../Common/ABSelect';
import {
  getEducation,
} from "../../Actions/educationActions";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABYear from '../Common/ABYear';
import ABUpload from '../Common/ABUpload';
import ABText from '../Common/ABText';
import EduSimpleSelect from './eduSimpleSelect';

const QuestionForm = (props) => {

  const dispatch = useDispatch();

  //Handling Initial States Floating Labels
  // const [formData, setFormData] = useState({
  //   qualification: null,
  //   course: null,
  //   university: null,
  //   collage: null,
  //   location: null,
  //   batchStart: null,
  //   batchEnd: null,
  //   documentType: null,
  // });

  //Handling Floating Labels
  // const handleFloatingLabels = (e) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [e.target.name]: e.target.value,
  //   }));
  // }

  // getting values to show in dropdowns
  const { degreeOptions, veridficationCourseNameOptions, qualificationOptions } = GetMasterData();

  // setting initials states to be used
  const [education, setEducation] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  //state used for form fields
  const [formVal, setFormVal] = useState({
    campusHire: null
  });

  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState({});



  //select option handler for getting the information of fileds thats is formatted as per the api format
  // const selectHandler = (value) => {
  //   setCheckDataRecord((prevState) => ({
  //     ...prevState,
  //     [value.fieldId]: value,
  //   }));
  //   console.log(checkDataRecord);
  // }

  //select option handler for getting nor select handler

  const selectHandler2 = (value) => {

    let elementErrorId = 'err_campusHire';

    var cols = document.getElementById(elementErrorId);
    cols.innerHTML = '';
   
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    console.log(formVal);

  }

  //form validation logic
  const formValidation = (formValues) => {


    const errors = {};
    let isError = false;

    // resetting all errors first

    var cols = document.getElementsByClassName('text-danger');
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = '';
    }


    let elementErrorId = 'err_campusHire';
    if (formVal['campusHire'] === null || formVal['campusHire'] == '') {
      // errors.formVal1 = "This field is required.";
      document.getElementById(elementErrorId).innerHTML = "This field is required.";
      isError = true;
      //password.current.style.border = "1px solid red";
    } else {
      // password.current.style.border = "1px solid #E1E4EB";
    }




    return isError;
  };
  // form save hansler
  const saveHandler = (event) => {

    event.preventDefault();

    const record = {};

    record.campusHire = formVal.campusHire;

    const err = formValidation(record);

    setIsSubmit(true);
    // const isValidationPassed = Object.keys(err).length === 0;

    if (err === true) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      // dispatch(loginUser(formData));

      console.log(record);
      props.campsuHireStaus(record);


    }
  }

  const options = [
    { value: '2', label: 'No' },
    { value: '1', label: 'Yes' },
  ];

  return (
    <>

      <div className="tab-content" id="myTabContent">


        <div className="row">


        <EduSimpleSelect
                        type={1} /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`campusHire`}
                        id={`campusHire`}
                        errId={`err_campusHire`}
                        // fieldId={value.fields.mode_of_qualification.id}
                        placeholder="Are you a campus Hire"
                        // autoComplete="off"
                        options={options}
                        // attachOther={true}
                        // verificationType={6}
                        selectOption={selectHandler2}
                        isRequired={1}
                        // errId={`err_${caseCheckId}_${value.fields.mode_of_qualification.id}`}
                        // caseCheckId={caseCheckId}
                        // returnType="name"
                        // value={newRecord[value.fields.mode_of_qualification.id]}
                        // selectedLabel={value.fields.mode_of_qualification.field_name}
                        // hiddenValue={value.fields.mode_of_qualification.field_value}
                        fieldName="mode_of_qualification"
                         checkDetailsIndex={1}
                      />

{/* 
          <ABSelect
            type={1}  type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}
            name={`campusHire`}
            id={`campusHire`}
            errId={`err_campusHire`}
            placeholder="Are you a campus Hire"
            // autoComplete="off"
            options={options}
            // attachOther={true}
            // verificationType={6}
            //    fieldId={value.fields.qualification_degree.id}
            selectOption={selectHandler2}
            isRequired={1}
          /> */}

        </div>


        <div className="row mt-3">
          <div className="col-auto d-flex justify-content-between">
            {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
            <button className="btn btn-primary btn-lg btn-block mt-3" onClick={saveHandler}>Save</button>
          </div>
        </div>
      </div>
    </>
  );
}
export default QuestionForm;